export enum StatusNotaAvariada{

	APROVADA =<number>1,
	REPROVADA =<number>2

}
